import { useViewModel } from '@utils';
import { CalendarViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import '../../styles/components/calendar/common.scss';
import { DayCalendar, MonthCalendar, WeekCalendar } from './views';

export const Calendar = observer(() => {

  const calendarViewModel = useViewModel(CalendarViewModel);

  // TODO: при установке интервала в фильтрах не должен отправляться запрос, пока мы не поменяем или не сбросим фильтр
  useEffect(() => calendarViewModel.getAllMeetings(),
    [calendarViewModel.endInterval, calendarViewModel.startInterval]);

  return (
    <>
      {calendarViewModel.filterInterval === 'day' && <DayCalendar />}
      {calendarViewModel.filterInterval === 'week' && <WeekCalendar />}
      {calendarViewModel.filterInterval === 'month' && <MonthCalendar />}
    </>
  );
});
